import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { markdownOptions } from '@/app/lib/markdown';
import { MarkdownPreviewProvider } from '@/app/providers/markdown';
import { NotificationsPage } from '@/notifications/pages';

export const Route = createFileRoute('/notifications')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: NotificationsRoute
});

function NotificationsRoute() {
  return (
    <MarkdownPreviewProvider options={markdownOptions}>
      <NotificationsPage/>
    </MarkdownPreviewProvider>
  );
}
